import styled from 'styled-components'

export const ImportWrapper = styled.div`
  display: grid;
  gap: 8px;
  grid-template-columns: 1fr auto;
`
